const tab_sections = {
    overview: 'Visão geral',
    resource_management: 'Recursos',
    user_management: 'Usuários',
    access_control: 'Controle de acesso',
    help_and_support: 'Ajuda e suporte',
};
export default tab_sections;
